/* src/app/shared/order-form/order-form/order-form-footer/order-form-footer.component.scss */
.header {
  margin-top: 40px;
}
.footer {
  margin-bottom: 20px;
}
/*# sourceMappingURL=order-form-footer.component.css.map */
